import heap from './heap';

function getDeviceProperties(UA) {
	let deviceName = ' ',
		platform = ' ',
		browser = ' ',
		isWindows = false;

	// Find first parentheses occurrence like- (Linux; Android 8.1.0; SM-T837A)
	deviceName = UA.match(/\(([^)]+)\)/);

	if (deviceName && deviceName.length) {
		let tempDeviceData = [];
		let tempDeviceName = deviceName;
		isWindows = tempDeviceName[1].match(/Win/gi) && tempDeviceName[1].match(/Win/gi).length;
		// Clean the device string by removing unnecessary strings like- U; en-us;
		tempDeviceName[1] = tempDeviceName[1].replace(/;\s\w+:(\w+(?:\.\w+)+)|(\s[a-z|A-Z]{1};)|(\s\w+-\w+;\s)/gi,'');
		tempDeviceData = tempDeviceName[1].split(';');

		if (tempDeviceData.length) {
			if (tempDeviceData.length === 3) {
				tempDeviceName = isWindows ? tempDeviceData[0] : tempDeviceData[2];
			} else if (tempDeviceData[0]) {
				tempDeviceName = tempDeviceData[0];
			}

			if (tempDeviceData.length === 4 && tempDeviceData[3]) {
				platform = tempDeviceData[3];
			} else if (tempDeviceData[1]) {
				platform = tempDeviceData[1];
			}
		}

		if (tempDeviceName && typeof tempDeviceName === 'string') {
			deviceName = tempDeviceName.replace(/[()]|(\w+\/\w.+)/, '');
			deviceName = deviceName.trim();
		}

		if (platform && typeof platform === 'string') {
			platform = platform.replace(/_/g, '.');
			platform = platform.trim();
		}
	}

	// Find all browser strings like Chrome/70.0
	browser = UA.match(/\w+\/(\w+(?:\.\w+)+)/g);

	if (browser && browser.length) {
		let tempBrowser = browser;
		let tempBrowserSlice = [];

		if (tempBrowser.length > 2) {
			// Remove first two indexes that are always be Mozilla/5.0 & AppleWebKit/537.36
			tempBrowserSlice = tempBrowser.slice(2);
			tempBrowser = tempBrowserSlice.join(' ').replace(/Safari\/[\d.]+/i, '');
		} else {
			tempBrowser = tempBrowser[1];
		}

		// For safari browser replace 'Version/<number>' with 'Safari'
		if (tempBrowserSlice.length === 2) {
			let arr1 = [];
			let arr2 = [];
			const versionRgex = /Version/i;

			arr1 = tempBrowserSlice[0].split('/');
			arr2 = tempBrowserSlice[1].split('/');

			if (arr1.length && versionRgex.test(arr1[0])) {
				arr1[0] = arr2[0];
				tempBrowser = arr1.join('/');
			}
			if (arr2.length && versionRgex.test(arr2[0])) {
				arr2[0] = arr1[0];
				tempBrowser = arr2.join('/');
			}
		}

		if (tempBrowser && typeof tempBrowser === 'string') {
			browser = tempBrowser.replaceAll('/', ' ');
			browser = browser.trim();
		}
	}
	return { deviceName, platform, browser };
}

function downlinkToEffectiveType(downlinkMbps) {
	if (downlinkMbps <= 0.05) {
		return 'slow-2g';
	}

	if (downlinkMbps <= 0.15) {
		return '2g';
	}

	if (downlinkMbps <= 0.7) {
		return '3g';
	}

	return '4g';
}

function isUncachedTimingEntry(entry) {
	if (!entry || entry.duration <= 0 || entry.transferSize <= 0) {
		return false;
	}

	// deliveryType is supported in modern browsers; cached hits can still have transferSize > 0 on revalidation
	if ('deliveryType' in entry && entry.deliveryType === 'cache') {
		return false;
	}

	return true;
}

function getNetworkProperties() {
	if (!('performance' in window) || typeof performance.getEntriesByType !== 'function') {
		return { networkEffectiveType: 'unknown' };
	}

	const allTimingEntries = performance.getEntriesByType('resource').concat(performance.getEntriesByType('navigation'));
	const uncachedTimingEntries = allTimingEntries.filter(isUncachedTimingEntry);
	const downlinks = [];

	for (let i = 0; i < uncachedTimingEntries.length; i++) {
		const entry = uncachedTimingEntries[i];
		downlinks.push((entry.transferSize * 8) / (entry.duration / 1000) / 1000000);
	}

	if (!downlinks.length) {
		const networkProperties = { networkEffectiveType: 'unknown' };

		if (allTimingEntries.length > 0) {
			networkProperties.allResourcesAreCached = true;
		}

		return networkProperties;
	}

	downlinks.sort((a, b) => a - b);
	const medianDownlink = downlinks[Math.floor(downlinks.length / 2)];

	return {
		networkEffectiveType: downlinkToEffectiveType(medianDownlink),
		downlinkMbps: Math.round(medianDownlink * 100) / 100
	};
}

export default function trackUserAgent() {
	const deviceProperties = {};
	if ('navigator' in window && 'userAgent' in navigator) {
		const { deviceName, browser, platform } = getDeviceProperties(navigator.userAgent);
		deviceProperties.device = deviceName;
		deviceProperties.browser = browser;
		deviceProperties.platform = platform;
		deviceProperties.UA = navigator.userAgent;
	}

	Object.assign(deviceProperties, getNetworkProperties());

	heap('track', ['Device Properties', deviceProperties]);
}
